import { Plugin } from 'hubspot-prosemirror/pm/state';
import { isUrl } from './linkify';

/**
 * This plugin is used to automatically add a link mark to the editor selection
 * when pasting a URL.
 */
export const AutoLinkOnPastePlugin = new Plugin({
  props: {
    handlePaste: (view, event, __slice) => {
      var _event$clipboardData;
      const pastedText = (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.getData('text/plain');
      if (pastedText && isUrl(pastedText) && !view.state.selection.empty) {
        const tr = view.state.tr.addMark(view.state.selection.from, view.state.selection.to, view.state.schema.marks.link.create({
          href: pastedText
        }));
        view.dispatch(tr);
        return true;
      }
    }
  }
});